'use client';

import React from "react";
import "../assets/styles/CertificationSection.scss";
import cert_img1 from '../assets/certificates/cert_ai.jpeg';
import cert_pdf1 from '../assets/certificates/cert_ai.pdf';

import uml_img1 from '../assets/certificates/uml.png';
import uml_pdf1 from '../assets/certificates/UML.pdf';

import algo_img1 from '../assets/certificates/algo.jpeg';
import GDS_img1 from '../assets/certificates/GenomicDS.jpeg';

import algo_pdf1 from '../assets/certificates/algo.pdf';
import GDS_pdf1 from '../assets/certificates/GenomicDS.pdf';

const featuredCert = {
  title: "Deep Learning Specialization",
  issuer: "DeepLearning.AI",
  date: "June 2024",
  description: "Mastered neural networks, CNNs, RNNs, and sequence models with Andrew Ng.",
  url: "https://www.coursera.org/account/accomplishments/specialization/GQ3CX6T4UBQV",
  download: cert_pdf1,
  image: cert_img1,
};

const certifications = [
  {
    title: "Algorithmic Toolbox",
    issuer: "University of California San Diego",
    date: "May 2020",
    url: "https://www.coursera.org/verify/38RXW8FNUTSP",
    tags: [
      "Algorithms", "Computational Thinking", "Software Testing", "Bioinformatics",
      "Programming Principles", "Test Engineering"
    ],
    download: algo_pdf1,
    image: algo_img1
  },
  {
    title: "Python for Genomic Data Science",
    issuer: "Johns Hopkins University",
    date: "May 2020",
    url: "https://www.coursera.org/verify/38RXW8FNUTSP",
    tags: [
      "Python", "Bioinformatics", "Jupyter", "Data Manipulation", "Data Processing",
      "Programming Principles", "Data Structures", "File Management", "Software Management"
    ],
    download: GDS_pdf1,
    image: GDS_img1,
  },
  {
    title: "Unified Modeling Language",
    issuer: "Stanford University",
    date: "Feb 2020",
    url: "https://coursera.org/verify/ml-stanford",
    tags: ["Database", "SQL", "UML"],
    download: uml_pdf1,
    image: uml_img1,
  },
];

const profileUrl = "https://www.linkedin.com/in/hafizahmadhassan";

export default function CertificationSection() {
  return (
    <section className="certifications-container" id="certifications">
      <h1>Certifications</h1>

      <div className="featured-cert">
        <h2>{featuredCert.title}</h2>
        <p>{featuredCert.description}</p>
        <p className="issuer">{featuredCert.issuer} · {featuredCert.date}</p>
        <img src={featuredCert.image} alt={featuredCert.title} className="cert-image" />

        <div className="cert-buttons">
          <a href={featuredCert.url} target="_blank" rel="noreferrer" className="verify-button">
            View Certificate
          </a>
          <a href={featuredCert.download} download className="download-button">
            Download PDF
          </a>
        </div>
      </div>

      <div className="certifications-scroll">
        {certifications.map((cert, index) => (
          <div className="cert-card zoom" key={index}>
            <img src={cert.image} alt={cert.title} className="cert-image" />
            <a href={cert.url} target="_blank" rel="noreferrer">
              <h2>{cert.title}</h2>
            </a>
            <p className="issuer">{cert.issuer} · {cert.date}</p>
            <div className="cert-tags">
              {cert.tags.map((tag, i) => (
                <span className="tag" key={i}>{tag}</span>
              ))}
            </div>
            <a href={cert.download} download className="download-button">
              Download PDF
            </a>
          </div>
        ))}
      </div>

      <div className="cert-actions">
        <a href={profileUrl} target="_blank" rel="noreferrer" className="connect-button">
          Connect on LinkedIn
        </a>
        <a href={profileUrl} target="_blank" rel="noreferrer" className="view-more-link">
          [View More]
        </a>
      </div>
    </section>
  );
}
